// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"d9e45591","126":"4d92238e","465":"4a93a910","787":"e6e0ccbc","840":"3fcda084"}[chunkId] + ".chunk.js";
};